import { formatAmountInr } from "../utils/common/functions";

export const VIEW_TYPE_MAPPER = {
  twoRowsImageCaurosel: "twoRowsImageCaurosel",
  singleCard: "singleCard",
  imageCaurosel: "imageCaurosel",
  cardHorizontalImageCaurosel: "cardHorizontalImageCaurosel",
  twoRowsImageCaurosel: "twoRowsImageCaurosel",
};

export const SUBCATEGORY_VIEW_TYPE_MAPPER = {
  Equity_Market_Cap: VIEW_TYPE_MAPPER.twoRowsImageCaurosel,
  Equity_Tax_Saving: VIEW_TYPE_MAPPER.singleCard,
  Equity_Sectors_and_Themes: VIEW_TYPE_MAPPER.imageCaurosel,
  Equity_Investment_Styles: VIEW_TYPE_MAPPER.cardHorizontalImageCaurosel,
  Debt_Duration: VIEW_TYPE_MAPPER.twoRowsImageCaurosel,
  Debt_Credit_Quality: VIEW_TYPE_MAPPER.cardHorizontalImageCaurosel,
  Debt_Investment_Styles: VIEW_TYPE_MAPPER.imageCaurosel,
  Hybrid_Investment_Styles: VIEW_TYPE_MAPPER.twoRowsImageCaurosel,
  Hybrid_More_Categories: VIEW_TYPE_MAPPER.cardHorizontalImageCaurosel,
  default: VIEW_TYPE_MAPPER.twoRowsImageCaurosel,
};

export const CART_LIMIT = 25;

export const FILTER_TYPES = {
  returns: "returns",
  sort: "sort",
};

export const FILTER_TAB_OPTIONS = [
  { id: 1, label: "Fund houses", testIdSuffix: "fundHouses" },
  { id: 2, label: "Fund options", testIdSuffix: "fundOptions" },
  { id: 3, label: "Minimum investment", testIdSuffix: "minimumInvestment" },
];

export const DEFAULT_FILTER_DATA = {
  fundOption: "growth",
  fundHouse: "",
  minimunInvestment: "",
  returnPeriod: "three_year_return",
  sortFundsBy: "returns",
  sortingOrder: "desc",
};

export const MINIMUM_INVESTMENT_OPTIONS = [
  {
    label: `Below ${formatAmountInr(500)}`,
    id: "<500",
    value: {
      lowerLimit: 0,
      upperLimit: 499,
    },
  },
  {
    label: `${formatAmountInr(500)} - ${formatAmountInr(1000)}`,
    id: "500-1000",
    value: {
      lowerLimit: 500,
      upperLimit: 1000,
    },
  },
  {
    label: `Above ${formatAmountInr(1000)}`,
    id: ">1000",
    value: {
      lowerLimit: 1001,
    },
  },
];

export const FUND_OPTIONS = [
  {
    label: "Growth",
    value: "growth",
  },
  {
    label: "Dividend",
    value: "dividend",
  },
];

export const RETURNS_DATA_LIST = [
  { label: "1 Month", value: "one_month_return", returnLabel: "1M" },
  { label: "3 Months", value: "three_month_return", returnLabel: "3M" },
  { label: "6 Months", value: "six_month_return", returnLabel: "6M" },
  { label: "1 Year", value: "one_year_return", returnLabel: "1Y" },
  { label: "3 Years", value: "three_year_return", returnLabel: "3Y" },
  { label: "5 Years", value: "five_year_return", returnLabel: "5Y" },
];

export const SORT_DATA_LIST = [
  {
    label1: "Returns",
    label2: "High to low",
    value: "returns",
    order: "desc",
    label1TestIdSuffix: "returns",
    label2TestIdSuffix: "howToLow1",
  },
  {
    label1: "Fund size (AUM)",
    label2: "High to low",
    value: "aum",
    order: "desc",
    label1TestIdSuffix: "fundSize",
    label2TestIdSuffix: "highToLow2",
  },
  {
    label1: "Expense ratio",
    label2: "Low to high",
    value: "expense_ratio",
    order: "asc",
    label1TestIdSuffix: "expenseRatio",
    label2TestIdSuffix: "lowToHigh",
  },
  {
    label1: "Rating",
    label2: "High to low",
    value: "fisdom_rating",
    order: "desc",
    label1TestIdSuffix: "rating",
    label2TestIdSuffix: "highToLow3",
  },
];

export const DIY_TYPE = {
  EQUITY: "EQUITY",
  DEBT: "DEBT",
  HYBRID: "HYBRID",
};

export const carouselFourTitleId = {
  EQUITY: "investmentStyles",
  DEBT: "creditQuality",
  HYBRID: "moreCategories",
};

export const carouselThreeTitleId = {
  EQUITY: "sectorAndThemes",
  DEBT: "investmentStyles",
  HYBRID: "",
};

export const carouselTwoTitlesId = {
  EQUITY: "marketCap",
  DEBT: "duration",
  HYBRID: "investmentStyles",
};

export const titleMapper = {
  EQUITY: "EQUITY",
  DEBT: "DEBT",
  HYBRID: "HYBRID",
};

export const carouselTwoTitles = {
  EQUITY: "Market cap",
  DEBT: "Duration",
  HYBRID: "Investment styles",
};

export const carouselThreeTitles = {
  EQUITY: "Sector and themes",
  DEBT: "Investment styles",
};

export const carouselFourTitles = {
  EQUITY: "Investment styles",
  DEBT: "Credit quality",
  HYBRID: "More categories",
};

export const graphTimeline = [
  { label: "1M", value: "1M" },
  { label: "3M", value: "3M" },
  { label: "6M", value: "6M" },
  { label: "1Y", value: "1Y" },
  { label: "3Y", value: "3Y" },
  { label: "5Y", value: "5Y" },
];

export const timelinePeriods = [
  { label: "1Y", value: 1 },
  { label: "3Y", value: 3 },
  { label: "5Y", value: 5 },
  { label: "10Y", value: 10 },
  { label: "15Y", value: 15 },
  { label: "20Y", value: 20 },
];
export const barData = [
  { label: "Low", value: 1 },
  { label: "Below Avg", value: 2 },
  { label: "medium", value: 3 },
  { label: "Above avg", value: 4 },
  { label: "High", value: 5 },
];

export const navPopupData = [
  { name: "Fund Stats", value: "stats" },
  { name: "Return Calculator", value: "returnCalc" },
  { name: "Asset allocation", value: "asset" },
  { name: "Returns", value: "returns" },
  { name: "Risk details", value: "risk" },
  { name: "Return comparison", value: "returnComp" },
];
